import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRewind: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rewind"><path d="M11.5906 11.3572L19.25 5.5V18.5L11.5906 12.6428M11.25 18.5L2.75 12L11.25 5.5V18.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRewind;
